'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function () {
  return create;

  function create(singleClickFn, doubleClickFn, delay) {
    var DELAY = delay || 700,
        clicks = 0,
        timer = null;

    return function handleClickEvent(e) {
      clicks++; //count clicks

      if (clicks === 1) {

        timer = setTimeout(function () {

          singleClickFn(e); //perform single-click action
          clicks = 0; //after action performed, reset counter
        }, DELAY);
      } else {

        clearTimeout(timer); //prevent single-click action
        doubleClickFn(e); //perform double-click action
        clicks = 0; //after action performed, reset counter
      }

      /*
       .on("dblclick", function (e) {
       e.preventDefault();  //cancel system double-click event
       });
       */
    };
  }
};

;


//////////////////
// WEBPACK FOOTER
// ./~/infocert-utils/distribution/utils.services/singleAndDoubleClick.js
// module id = 19
// module chunks = 2